import { render } from "./Anomalie.vue?vue&type=template&id=4f3cdf82&scoped=true"
import script from "./Anomalie.vue?vue&type=script&lang=js"
export * from "./Anomalie.vue?vue&type=script&lang=js"

import "./Anomalie.vue?vue&type=style&index=0&id=4f3cdf82&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3cdf82"]])

export default __exports__